import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { getPAGAA000, postPAHAF010 } from '../../../services/Api';
import Nav from '../../../shared/components/Nav';
import Pagination from '../../../shared/components/Pagination';
import { MENU_CUSTOMER_SERVICE_CENTER } from '../../../shared/constants/app';
import { formatDate, updateMenuVisibility } from '../../../utils';
const PAHAF010 = () => {
    const [pages, setPages] = useState({});
    const [dataNews, setDataNews] = useState({});
    const [prepareData, setPrepareData] = useState({});
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [customerServiceMenu, setCustomerServiceMenu] = useState([]);

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedCustomerServiceMenu = updateMenuVisibility(data, MENU_CUSTOMER_SERVICE_CENTER);
                setCustomerServiceMenu(updatedCustomerServiceMenu);
            })
            .catch((error) => console.log(error));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPrepareData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const getListData = () => {
        postPAHAF010({
            page,
            keyword: prepareData?.news,
        })
            .then(({ data }) => {
                setPages(data.info);
                setDataNews(data.data);
            })
            .catch((error) => console.log(error));
    };
    const getGubun = (gubun) => {
        switch (gubun) {
            case '01':
                return '공지';
            case '02':
                return '소식';
            default:
                return '';
        }
    };
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleSearch();
        }
    };
    const handleSearch = () => {
        getListData();
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page]);
    return (
        <div id="content">
            <Nav menu={customerServiceMenu} />
            <div id="notification" style={{ marginTop: 39 }}>
                <div className="container">
                    <div className="section-wrapper">
                        <div className="left-item">
                            <div className="header-frame">
                                <div className="titleText">공지/소식</div>
                                <div className="search-form">
                                    <input
                                        style={{ borderRadius: '10px' }}
                                        type="text"
                                        name="news"
                                        placeholder="검색어 입력"
                                        onChange={handleChange}
                                        onKeyPress={handleKeyPress}
                                    />
                                    <i className="icon icon-magnifying-glass-line pointer" onClick={handleSearch} />
                                </div>
                            </div>
                            <div className="content-frame">
                                <ul className="table content-table">
                                    <li className="table-header">
                                        <div className="header-item">구분</div>
                                        <div className="header-item">제목</div>
                                        <div className="header-item">일자</div>
                                    </li>
                                    {dataNews && dataNews.length > 0 ? (
                                        dataNews.map((item, index) => {
                                            return (
                                                <li
                                                    className={`flex wrap-item ${item?.notice === 'Y' ? 'bg_f7faff' : ''
                                                        }`}
                                                    key={`news-${index}`}
                                                >
                                                    <div className="flex wrap-left">
                                                        <div
                                                            className={`status ${item?.gubun === '01'
                                                                    ? 'blue'
                                                                    : item?.gubun === '02'
                                                                        ? 'green'
                                                                        : ''
                                                                } `}
                                                        >
                                                            {getGubun(item?.gubun)}
                                                        </div>
                                                        <h4 className="item-title">
                                                            <Link to={`/pahaf020-${item?.seq}`}>{item?.title}</Link>
                                                        </h4>
                                                    </div>
                                                    <div className="date font-dotum">{formatDate(item?.addDate)}</div>
                                                </li>
                                            );
                                        })
                                    ) : (
                                        <li className="no-data">데이터없습니다</li>
                                    )}
                                </ul>
                            </div>
                            <Pagination pages={pages} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PAHAF010;
